import axios from 'axios';
import environmentConfig from './environment';

// API Configuration
const config = {
  // Base API URL - automatically determined by environment
  API_BASE_URL: environmentConfig.API_BASE_URL,

  // API Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/user/login',
      LOGOUT: '/api/user/logout',
      REFRESH: '/api/user/refresh'
    },
    USER: {
      GET_PROFILE: '/api/user/profile',
      IS_ADMIN: '/api/User/isAdmin',
      FIRE_DRIVER: '/api/User/FireDriver',
      FIRE_DISPATCHER: '/api/User/FireDispatcher',
      GET_FIRED_WORKERS: '/api/User/GetFiredWorkers',
      UPDATE_PASSWORD: '/api/user/UpdatePassword',
      FORGOT_PASSWORD: '/api/user/ForgotPassword'
    },
    RIDES: {
      CREATE: '/api/Ride/AddRide',
      GET_ALL: '/api/Ride/Open',
      GET_BY_ID: '/api/Ride/GetById',
      GET_ASSIGNED: '/api/Ride/AssignedRides',
      GET_IN_PROGRESS: '/api/Ride/CurrentlyBeingDriven',
      GET_FUTURE: '/api/Ride/FutureRides',
      GET_TODAY: '/api/Ride/TodaysRides',
      GET_OPEN: '/api/Ride/Open',
      GET_THIS_WEEK: '/api/Ride/RidesThisWeek',
      GET_ALL_HISTORY: '/api/Ride/AllRides',
      GET_ALL_HISTORY_PAGINATED: '/api/Ride/AllRidesPaginated',
      GET_FILTERED_RIDES_PAGINATED: '/api/Ride/FilteredRidesPaginated',
      GET_RIDES_FOR_WEEK: '/api/Ride/RidesForWeek',
      FIND_RIDE_PAGE: '/api/Ride/FindRidePage',
      FIND_RIDE_WEEK_AND_PAGE: '/api/Ride/FindRideWeekAndPage',
      UPDATE: '/api/rides',
      // DELETE: '/api/rides',
      ASSIGN: '/api/Ride/AssignToDriver',
      CANCEL: '/api/Ride/CancelRide',
      CANCEL_RECURRING: '/api/Ride/CancelRecurring',
      CANCEL_RECURRING_WITH_OPTION: '/api/Ride/CancelRecurringWithOption',
      REASSIGN: '/api/Ride/Reassign',
      PICKUP: '/api/Ride/Pickup',
      DROPOFF: '/api/Ride/Dropoff',
      UPDATE_STATUS: '/api/Ride/UpdateStatus',
      CALCULATE_PRICE: '/api/Ride/CalculatePrice',
      CALCULATE_STOPS_COST: '/api/Ride/CalculateStopsCost',
      RESET_PICKUP: '/api/Ride/ResetPickupTime',
      UPDATE_PRICE: '/api/Ride/UpdatePrice',
      SET_PAID_STATUS: '/api/Ride/SetPaidStatus',
      SET_STATUS: '/api/Ride/SetStatus',
      MARK_CARD_CHARGED: '/api/Ride/MarkCardCharged',
      DISPATCHER_COMPLETE_RIDE: '/api/Ride/DispatcherCompleteRide',
      DISPATCHER_UNCOMPLETE_RIDE: '/api/Ride/DispatcherUncompleteRide',
      UNSETTLED_RIDES_BY_DRIVER: '/api/Ride/UnsettledRides',
      SETTLE_UP_DRIVER: '/api/Ride/SettleUpDriver',
      SETTLE_RIDE: '/api/Ride/SettleRide',
      SEND_RECEIPT: '/api/Ride/SendReceipt'
    },
    INVOICES: {
      GET_DRIVERS_WITH_INVOICES: '/api/Ride/Invoices/Drivers',
      GET_DRIVER_INVOICES: '/api/Ride/Invoices/Driver',
      DOWNLOAD: '/api/Ride/Invoices/Download',
      RESEND: '/api/Ride/Invoices/Resend'
    },
    DASHBOARD: {
      GET_ALL: '/api/Ride/Dashboard',
      ASSIGNED_RIDES: '/api/Ride/Dashboard/AssignedRides',
      OPEN_RIDES: '/api/Ride/Dashboard/OpenRides',
      RIDES_IN_PROGRESS: '/api/Ride/Dashboard/RidesInProgress',
      COMPLETED_UNREVIEWED: '/api/Ride/Dashboard/CompletedUnreviewedRides',
      RECURRING_RIDES_THIS_WEEK: '/api/Ride/Dashboard/RecurringRidesThisWeek',
      TODAYS_RIDES: '/api/Ride/Dashboard/TodaysRides',
      TODAYS_RECURRING_RIDES: '/api/Ride/Dashboard/TodaysRecurringRides',
      ACTIVE_DRIVERS: '/api/User/Dashboard/ActiveDrivers',
      OFFLINE_DRIVERS: '/api/User/Dashboard/OfflineDrivers',
      ALL_DRIVERS_WITH_STATUS: '/api/User/Dashboard/AllDriversWithStatus',
      DRIVERS_ON_JOB: '/api/User/Dashboard/DriversOnJob',
      UNSETTLED_DRIVERS: '/api/Ride/Dashboard/UnsettledDrivers',
      FUTURE_RIDES: '/api/Ride/Dashboard/FutureRides',
      MARK_AS_REVIEWED: '/api/Ride/MarkAsReviewed'
    },
    DRIVERS: {
      GET_ALL: '/api/User/AllDrivers',
      GET_BY_ID: '/api/User/DriverById',
      GET_ACTIVE: '/api/User/ActiveDrivers',
      GET_DRIVING: '/api/User/ActiveDriversOnCall',
      GET_DRIVERS_DRIVING: '/api/User/getDriversDriving',
      GET_ONLINE_DRIVERS: '/api/User/getOnlineDrivers',
      GET_TRACKING_LOST_ALERTS: '/api/User/getTrackingLostAlerts',
      CREATE: '/api/User/AddDriver',
      UPDATE: '/api/User/UpdateDriver',
      GET_DRIVER_STATUS: '/api/User/getDriverStatus',
      // Driver onboarding / applications
      INVITE: '/api/User/InviteDriver',
      GET_APPLICATIONS: '/api/User/DriverApplications',
      GET_APPLICATION_BY_ID: '/api/User/DriverApplications', // + /{id}
      APPROVE_APPLICATION: '/api/User/ApproveDriver',         // + /{id}
      REJECT_APPLICATION: '/api/User/RejectDriver',           // + /{id}
      RESEND_INVITE: '/api/User/ResendDriverInvite',          // + /{id}
      CANCEL_INVITE: '/api/User/CancelDriverInvite',          // + /{id}
      GET_DOCUMENT: '/api/User/DriverDocument',               // + /{driverId}/{type}
      UPLOAD_DOCUMENT: '/api/User/UploadDriverDocument',      // + /{driverId}/{type}
      DELETE_DOCUMENT: '/api/User/DriverDocument',            // DELETE + /{driverId}/{type}
      REVEAL_SSN: '/api/User/RevealSsn',                      // + /{driverId}
    },
    DISPATCHERS: {
      GET_ACTIVE: '/api/User/ActiveDispatchers',
      GET_BY_ID: '/api/User/DispatcherById',
      CREATE: '/api/User/AddDispatcher',
      UPDATE: '/api/User/UpdateDispatcher',
      GET_PHOTO: '/api/User/DispatcherPhoto',        // + /{id}
      UPLOAD_PHOTO: '/api/User/UploadDispatcherPhoto', // + /{id}
      DELETE_PHOTO: '/api/User/DispatcherPhoto',       // DELETE + /{id}
    },
    CARS: {
      GET_BY_DRIVER: '/api/User/getCars',
      CREATE: '/api/User/AddCar',
      DISPATCHER_UPDATE: '/api/User/DispatcherUpdateCar',
      DISABLE: '/api/User/DisableCar',
      ENABLE: '/api/User/EnableCar',  // + /{carId}
    },
    MESSAGES: {
      SEND_MESSAGE: '/api/Communication/AddCom',
      GET_TODAY_MESSAGES: '/api/Communication/TodaysCom',
      GET_ALL_MESSAGES: '/api/Communication/AllCom',
      GET_BROADCAST_MESSAGES: '/api/Communication/BroadcastComs',
      GET_UNREAD_COUNT: '/api/Communication/driverUnreadCount',
      MARK_READ: '/api/Communication/MarkAsRead',
      // GET_UNREAD_COUNT: '/api/messages/unreadCount',
      GET_UNREAD: '/api/Communication/Unread',

    },
    PAYMENT: {
      CONFIG: '/api/Payment/Config',
      CHARGE_CARD: '/api/Payment/ChargeCard',
      VERIFY_TOKEN: '/api/Payment/VerifyToken',
      SQUARE_CONFIG: '/api/Payment/SquareConfig',
      SAVE_CARD_ON_FILE: '/api/Payment/SaveCardOnFile',
    },
    SETTINGS: {
      GET: '/api/Settings',
      UPDATE: '/api/Settings',
    },
    PRICING: {
      ZONES: '/api/Pricing/Zones',
      ZONE_BY_ID: '/api/Pricing/Zones',        // + /{id}
      ZONES_REORDER: '/api/Pricing/Zones/reorder',
      ROUTES: '/api/Pricing/Routes',
      ROUTES_SINGLE: '/api/Pricing/Routes/single',
      ROUTE_BY_ID: '/api/Pricing/Routes',       // + /{id}
      ROUTES_UPDATE_BOTH: '/api/Pricing/Routes/UpdateBoth',  // + /{id}
      FORMULA_SETTINGS: '/api/Pricing/FormulaSettings',
      ZIP_CODE_SEARCH: '/api/Pricing/ZipCodeSearch',
      ZIP_CODE_RESOLVE: '/api/Pricing/ZipCodeResolve',
      RUSH_HOUR_FEES: '/api/Pricing/RushHourFees',
    },
    CAR_TYPES: {
      GET_ALL: '/api/CarType/all',
      GET_ALL_INCLUDING_INACTIVE: '/api/CarType/all-including-inactive',
      CREATE: '/api/CarType/create',
      UPDATE: '/api/CarType/update',             // + /{id}
      DEACTIVATE: '/api/CarType/deactivate',     // + /{id}
      REACTIVATE: '/api/CarType/reactivate',     // + /{id}
      PRICING_COMPLETE: '/api/CarType/pricing-complete',
      ROUTE_PAIRS: '/api/CarType/route-pairs',
    },
    EMAIL_TEMPLATES: {
      GET_ALL: '/api/EmailTemplate',
      GET_BY_KEY: '/api/EmailTemplate',         // + /{key}
      UPDATE: '/api/EmailTemplate',             // PUT + /{key}
      RESET: '/api/EmailTemplate',              // POST + /{key}/reset
      PREVIEW: '/api/EmailTemplate',            // POST + /{key}/preview
      SEND_TEST: '/api/EmailTemplate',          // POST + /{key}/sendTest
    },
    ADD_ONS: {
      GET_ACTIVE: '/api/AddOn',
      GET_ALL: '/api/AddOn/all',
      CREATE: '/api/AddOn',
      UPDATE: '/api/AddOn',        // + /{id}
      DELETE: '/api/AddOn',        // + /{id}
      REACTIVATE: '/api/AddOn',    // + /{id}/reactivate
    },
    ACCOUNTS: {
      GET_ALL: '/api/Account',
      GET_BY_ID: '/api/Account',      // + /{id}
      SEARCH: '/api/Account/search',  // ?q=
      CREATE: '/api/Account',
      UPDATE: '/api/Account',         // + /{id}
      DEACTIVATE: '/api/Account',     // DELETE + /{id}
      REACTIVATE: '/api/Account',     // POST + /{id}/reactivate
      ATTACH_CARD: '/api/Account',    // POST + /{id}/card
      REMOVE_CARD: '/api/Account',    // DELETE + /{id}/card
    },
    AGREEMENTS: {
      GET_ALL: '/api/Agreement',          // GET
      UPLOAD: '/api/Agreement',          // POST multipart
      UPDATE_META: '/api/Agreement',          // PUT + /{id}/meta
      REPLACE_PDF: '/api/Agreement',          // PUT + /{id}/pdf
      DELETE: '/api/Agreement',          // DELETE + /{id}
      DOWNLOAD_BLANK: '/api/Agreement',          // GET + /{id}/pdf
      GET_SIGNED: '/api/Agreement/signed',   // GET + /{driverId}
      DOWNLOAD_SIGNED: '/api/Agreement/signed',   // GET + /{driverId}/{signedId}/pdf
    }
  },

  // Request timeout in milliseconds (30s allows for Azure SQL cold-start)
  TIMEOUT: 30000
};

// Create axios instance WITHOUT baseURL — set dynamically once company is resolved
const apiClient = axios.create({
  timeout: config.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Set the API base URL dynamically (called by CompanyContext on resolve)
export const setApiBaseUrl = (url) => {
  apiClient.defaults.baseURL = url || undefined;
};

// JWT Token Management — namespaced per company code
let _companyCode = null;

const getTokenKey = () => _companyCode ? `dispatch_jwt_token_${_companyCode}` : 'dispatch_jwt_token';
const getAuthKey = () => _companyCode ? `dispatcherAuth_${_companyCode}` : 'dispatcherAuth';

// Global reference to AuthContext's forceLogout function
let globalForceLogout = null;
// Global reference to get current company login path for redirects
let globalGetLoginPath = null;

export const setForceLogoutCallback = (callback) => {
  globalForceLogout = callback;
};

export const setGetLoginPathCallback = (callback) => {
  globalGetLoginPath = callback;
};

export const tokenManager = {
  getToken: () => {
    return localStorage.getItem(getTokenKey());
  },

  setToken: (token) => {
    if (token) {
      localStorage.setItem(getTokenKey(), token);
    }
  },

  removeToken: () => {
    localStorage.removeItem(getTokenKey());
  },

  hasToken: () => {
    return !!localStorage.getItem(getTokenKey());
  },

  // Called by CompanyContext when company is resolved/cleared
  setCompanyCode: (code) => {
    _companyCode = code;
  },

  getAuthKey,
  getTokenKey,
};

// Request interceptor - adds JWT token to all requests
apiClient.interceptors.request.use(
  (config) => {
    const token = tokenManager.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log request details in development
    if (__DEV__) {
      console.log('API Request:', {
        method: config.method?.toUpperCase(),
        url: config.url,
        hasToken: !!token,
        authorization: config.headers.Authorization,
        body: config.data
      });
    }

    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor - handles errors and token refresh
apiClient.interceptors.response.use(
  (response) => {
    // Log response in development
    if (__DEV__) {
      console.log('API Response:', {
        status: response.status,
        url: response.config.url,
        response: response.data
      });
    }


    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Log error details FIRST (persists in console even after redirect)
    console.error('=== API ERROR DETAILS ===');
    console.error('Status:', error.response?.status);
    console.error('Message:', error.message);
    console.error('URL:', error.config?.url);
    console.error('Full URL:', `${error.config?.baseURL}${error.config?.url}`);
    console.error('Response Data:', error.response?.data);
    console.error('Request Data:', error.config?.data);
    console.error('========================');

    // Don't try to refresh token on login endpoint (401 means invalid credentials)
    const isLoginEndpoint = error.config?.url?.includes('/login');

    // Handle 401 Unauthorized - token expired or invalid (but not on login page)
    if (error.response?.status === 401 && !originalRequest._retry && !isLoginEndpoint) {
      originalRequest._retry = true;

      // Only try to refresh if we have a token
      const currentToken = tokenManager.getToken();
      if (!currentToken) {
        console.error('No token available - cannot refresh');
        // Force logout since we have no token
        if (globalForceLogout) {
          await globalForceLogout();
        }
        // Redirect to login if not already there
        const loginPath = globalGetLoginPath ? globalGetLoginPath() : '/';
        if (!window.location.pathname.includes('/login') && window.location.pathname !== '/') {
          window.location.href = loginPath;
        }
        return Promise.reject(error);
      }

      // Try to refresh token
      try {
        const response = await axios.post(
          `${apiClient.defaults.baseURL}${config.ENDPOINTS.AUTH.REFRESH}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${currentToken}`
            }
          }
        );

        if (response.data?.token) {
          tokenManager.setToken(response.data.token);
          originalRequest.headers.Authorization = `Bearer ${response.data.token}`;
          return apiClient(originalRequest);
        }
      } catch (refreshError) {
        // Refresh failed - clear token and force logout
        console.error('Token refresh failed - logging out');
        tokenManager.removeToken();

        // Call forceLogout if available to update UI state
        if (globalForceLogout) {
          await globalForceLogout();
        }

        // Only redirect if NOT already on login page / landing page
        const loginPath = globalGetLoginPath ? globalGetLoginPath() : '/';
        if (!window.location.pathname.includes('/login') && window.location.pathname !== '/') {
          window.location.href = loginPath;
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// Export the axios instance and config
export { apiClient };
export default config;